import NavBar from '@/components/Nav.vue';

export default {
    name: 'AlbumPage',
    components: {
        NavBar,
    },
    data() {
        return {
            page: 1,
            more: true,
            loading: false,
            albums: [],
        }
    },
    created() {
        this.getAlbumList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getAlbumList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('album', {params: {page: this.page}}).then(result => {
                    this.page++;
                    this.loading = false;
                    this.more = result.data.more;
                    this.albums = this.albums.concat(result.data.albums);
                })
            }
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getAlbumList();
            }
        }
    }
}